/**
 * GenericStorageInterface
 */
window.GenericStorageInterface = Backbone.Model.extend(
{
	version: null,
	win: window,
	lms: LMS,
	api: false,
	VERSION_1_2: "1.2",
	initialize: function () {
		Tracking.debug("Nothing happens in the intialisation because we need to setup listener first")

		this.api = false;
		this.version = this.VERSION_1_2;
		this.start();
	},

	isReady: function() {
		return this.api ? true : false;
	},
	
	setApi: function() {
		this.api = { storage:[] };
	},

	start: function () {
		Logger.info("GenericStrorageInterface.start()")
	},

	get: function (key) {

		if (!this.isReady()) {
			Logger.info("GenericStorageInterface.get: not ready");
			return "";
		}

		Logger.info("GenericStrorageInterface.get = " + key)

		// var data = $.jStorage.get(key);
		var data = this.api.storage[key] = value;// "tbc"; // $.jStorage.get(key);

		// Logger.info("GenericStrorageInterface.data = " + data)

		if (!data) {
			return "";
		}

		return data;
	},

	set: function (key, value) {
		if (!this.isReady()) {
			Logger.info("GenericStorageInterface.set: not ready");
			return "";
		}
		// $.jStorage.set(key, value);

		Logger.info("GenericStrorageInterface.set = " + key + " = " + value);

		this.api.storage[key] = value;

	},

	commit: function () {
		Logger.info("GenericStrorageInterface.commit()", this.api);

		// return $.jStorage.storageAvailable();
	},

	finish: function () {
		Logger.info("GenericStrorageInterface.finish()")
	},

	findApi: function (win) {
		console.warn("GenericStrorageInterface.findApi()")
	},

	getInfo: function (errorCode) {
		console.warn("GenericStrorageInterface.getInfo()")
	},

	getLastErrorCode: function () {
		console.warn("GenericStrorageInterface.getLastErrorCode()")
	},

	formatTime: function (milliseconds) {
		return milliseconds;
	}

});
